// Palette for assistant markdown, scoped under `.ai-agent-chat-scope`. Keep in
// sync with `backend/app/prompts/skills/rich-formatting/instructions.md`.
// Idempotent so HMR doesn't stack duplicate <style> blocks; border longhand
// avoids clobbering `github-markdown-css` table borders.
import { glob } from 'goober';
import { appColors } from '@base/useTheme';

let installed = false;

export function installAiAgentChatColors() {
    if (installed) return;
    installed = true;

    void glob`
        .ai-agent-chat-scope .ai-agent-chat-text-default { color: ${appColors.neutral.w800}; }
        .ai-agent-chat-scope .ai-agent-chat-text-muted   { color: ${appColors.neutral.w700}; }
        .ai-agent-chat-scope .ai-agent-chat-text-strong  { color: ${appColors.neutral.w900}; }
        .ai-agent-chat-scope .ai-agent-chat-text-primary { color: ${appColors.primary.w500}; }
        .ai-agent-chat-scope .ai-agent-chat-text-success { color: ${appColors.success.w700}; }
        .ai-agent-chat-scope .ai-agent-chat-text-warning { color: ${appColors.warning.w700}; }
        .ai-agent-chat-scope .ai-agent-chat-text-error   { color: ${appColors.error.w700}; }

        .ai-agent-chat-scope .ai-agent-chat-bg-default { background-color: ${appColors.ui.white}; }
        .ai-agent-chat-scope .ai-agent-chat-bg-subtle  { background-color: ${appColors.neutral.w50}; }
        .ai-agent-chat-scope .ai-agent-chat-bg-primary { background-color: ${appColors.primary.w50}; }
        .ai-agent-chat-scope .ai-agent-chat-bg-success { background-color: ${appColors.success.w50}; }
        .ai-agent-chat-scope .ai-agent-chat-bg-warning { background-color: ${appColors.warning.w50}; }
        .ai-agent-chat-scope .ai-agent-chat-bg-error   { background-color: ${appColors.error.w50}; }

        .ai-agent-chat-scope .ai-agent-chat-border-default {
            border-width: 1px;
            border-style: solid;
            border-color: ${appColors.neutral.w200};
        }
        .ai-agent-chat-scope .ai-agent-chat-border-strong {
            border-width: 1px;
            border-style: solid;
            border-color: ${appColors.neutral.w400};
        }
    `;
}
